module.exports = __webpack_public_path__ + "static/media/educazione-finanziaria_budget.0c15c19f.png";